import React from "react";
import { ReactComponent as Mov } from "../../assets/new-icons/movimenti.svg";
import { ReactComponent as Doc } from "../../assets/new-icons/doc.svg";
import { ReactComponent as Con } from "../../assets/new-icons/consumi.svg";
import {ReactComponent as FdtIcon} from '../../assets/new-icons/faiDaTeIcon.svg';

import './_header.scss'

function Header({title, description, icon = 'mov'}) {
  
  return (
    <div className="head">
      <div className="head-top">
        <h2 className="title">{title}</h2>
      </div>

      <div dangerouslySetInnerHTML={{ __html: description }} />
      
    </div>
  );
}

export default Header;
